import { clientV3SDK } from "@istari-frontend/api-client";
import { useQuery } from "@tanstack/react-query";

export const userModelsKey = ["ai-user-models"] as const;

// The models an admin published for this environment (F12). Returns the raw
// `UserSelectableModelDto[]` — the picker references DTO fields directly.
export function useUserSelectableModels() {
  return useQuery({
    queryKey: userModelsKey,
    queryFn: () => clientV3SDK.aiListUserModels(),
    select: (response) => response.models,
  });
}
